import type {RouteRecordRaw} from "vue-router";
import {EPermissao} from "@/core/type/permissao.type";

export const nfseRoutes: RouteRecordRaw[] = [
    {
        path: "/nfse",
        name: "nfse",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_CONSULTAR_DFE_NFSE},
        component: () => import("@/modules/nfse/pages/PageNfse.vue")
    },
];
